import { AssignableQuestionnaire } from 'src/graphql.generated'

export const QUESTIONNAIRE_LABELS: Record<AssignableQuestionnaire, string> = {
  [AssignableQuestionnaire.Pcl5]: 'PCL-5',
  [AssignableQuestionnaire.Asrm]: 'ASRM',
  [AssignableQuestionnaire.Ocir]: 'OCI-R',
  [AssignableQuestionnaire.Isi]: 'ISI',
}

export const BUILT_IN_QUESTIONNAIRES = Object.values(AssignableQuestionnaire)
